import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { 
  Checkbox, 
  FormControlLabel, 
  Box, 
  Button, 
  Container,
  useTheme,
  useMediaQuery 
} from "@mui/material";
import Consentement from "./Consentement";
import themeNutriFast from "../styles/NutriFastColors";

const Formulaire = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const defaultValues = {
    consentement: false,
  };

  let navigate = useNavigate();

  const onSubmit = (data) => {
    navigate("/inscription", { state: data.consentement });
  };

  const { register, handleSubmit, watch } = useForm({
    defaultValues: defaultValues,
  });

  const watchConsentement = watch("consentement");

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 4 } }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Consentement />
        
        <Box 
          className="consentement-confirmation"
          sx={{ 
            my: { xs: 3, md: 4 },
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: 1
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                {...register("consentement", { required: true })}
                checked={watchConsentement}
                sx={{
                  color: themeNutriFast.palette.primary.main,
                  '&.Mui-checked': {
                    color: themeNutriFast.palette.primary.dark,
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: { xs: '1.2rem', md: '1.5rem' }
                  }
                }}
              />
            }
            label={
              <Box sx={{ 
                fontSize: { xs: '0.9rem', md: '1rem' },
                lineHeight: 1.4,
                maxWidth: { xs: '280px', md: '400px' }
              }}>
                En cochant cette case, j'accepte toutes les affirmations ci-dessus.
              </Box>
            }
            sx={{ 
              alignItems: 'flex-start',
              m: 0 
            }}
          />
        </Box>
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Button
            type="submit"
            variant="contained"
            disabled={!watchConsentement}
            sx={{
              backgroundColor: themeNutriFast.palette.primary.dark,
              color: 'white',
              px: { xs: 4, md: 6 },
              py: { xs: 1.5, md: 2 },
              fontSize: { xs: '0.9rem', md: '1rem' },
              fontWeight: 600,
              borderRadius: 2,
              textTransform: 'none',
              width: { xs: '80%', sm: '50%', md: '30%' },
              '&:hover': {
                backgroundColor: themeNutriFast.palette.primary.main,
              },
              '&:disabled': {
                backgroundColor: 'rgba(0, 0, 0, 0.12)',
                color: 'rgba(0, 0, 0, 0.26)'
              }
            }}
          >
            Suivant
          </Button>
        </Box>
      </form>
    </Container>
  );
};

export default Formulaire;
